// src/components/TabelaTiposServico.jsx
import { useEffect, useState } from "react";
import ConfirmarExclusaoModal from "./ConfirmarExclusaoModal";
import TabelaTiposServicoTable from "./TabelaTiposServicoTable";
import toast from "react-hot-toast"; // ✅ Toast para feedback

const API_URL = process.env.REACT_APP_API_URL;

export default function TabelaTiposServico({ onEditar }) {
  const [dados, setDados] = useState([]);
  const [filtro, setFiltro] = useState({ codigo: "", nome: "" });
  const [colunaAtiva, setColunaAtiva] = useState(null);

  // paginação
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [itensPorPagina, setItensPorPagina] = useState(10);

  // modal de exclusão
  const [modalAberto, setModalAberto] = useState(false);
  const [itemSelecionado, setItemSelecionado] = useState(null);

  // carregar dados da API
  const carregarDados = async () => {
    try {
      const resp = await fetch(`${API_URL}/tipo-servico/listar.php`);
      const data = await resp.json();
      if (data.status === "sucesso") setDados(data.dados);
    } catch (err) {
      console.error("Erro ao buscar tipos de serviço:", err);
    }
  };

  useEffect(() => {
    carregarDados();
  }, []);

  // abrir modal de exclusão
  const handleExcluirClick = (item) => {
    setItemSelecionado(item);
    setModalAberto(true);
  };

  // confirmar exclusão com toast único
  const handleConfirmarExclusao = async () => {
    if (!itemSelecionado) return;

    toast.promise(
      fetch(`${API_URL}/tipo-servico/excluir.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: itemSelecionado.id }),
      }).then(async (resp) => {
        const data = await resp.json();
        if (data.status !== "sucesso") {
          throw new Error(data.mensagem || "Erro ao excluir");
        }
        return data;
      }),
      {
        loading: "⏳ Excluindo tipo de serviço...",
        success: () => {
          carregarDados();
          return "✅ Tipo de serviço excluído com sucesso!";
        },
        error: (err) => `❌ ${err.message}`,
      }
    );

    setModalAberto(false);
    setItemSelecionado(null);
  };

  // filtro
  const dadosFiltrados = dados.filter(
    (item) =>
      item.codigo.toString().includes(filtro.codigo) &&
      item.nome.toLowerCase().includes(filtro.nome.toLowerCase())
  );

  // paginação
  const indiceInicial = (paginaAtual - 1) * itensPorPagina;
  const indiceFinal = indiceInicial + itensPorPagina;
  const dadosPaginados =
    itensPorPagina === Infinity
      ? dadosFiltrados
      : dadosFiltrados.slice(indiceInicial, indiceFinal);

  const totalPaginas =
    itensPorPagina === Infinity
      ? 1
      : Math.ceil(dadosFiltrados.length / itensPorPagina);

  return (
    <div className="flex-1 overflow-auto border-t border-slate-400 p-4">
      {/* tabela extraída para outro componente */}
      <TabelaTiposServicoTable
        dados={dadosPaginados}
        filtro={filtro}
        setFiltro={setFiltro}
        colunaAtiva={colunaAtiva}
        setColunaAtiva={setColunaAtiva}
        paginaAtual={paginaAtual}
        setPaginaAtual={setPaginaAtual}
        totalPaginas={totalPaginas}
        itensPorPagina={itensPorPagina}
        setItensPorPagina={setItensPorPagina}
        onEditar={onEditar}
        onExcluir={handleExcluirClick}
      />

      {/* Modal de confirmação */}
      <ConfirmarExclusaoModal
        aberto={modalAberto}
        onFechar={() => {
          setModalAberto(false);
          setItemSelecionado(null);
        }}
        onConfirmar={handleConfirmarExclusao}
        item={itemSelecionado}
      />
    </div>
  );
}
